module.exports = __webpack_public_path__ + "static/s105_large-daaacb1558aa24e16db3ef8373bb173f.jpg";